import type { FC, InputHTMLAttributes, ReactNode } from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string
    label: string
    hint?: ReactNode
}

export const FormField: FC<FormFieldProps> = ({ id, label, hint, className, ...props }): ReactNode => (
    <div className='flex flex-col gap-2'>
        <div className='flex items-center justify-between gap-2'>
            <Label htmlFor={id}>
                {label}
            </Label>
            {hint}
        </div>
        <Input id={id} className={className ?? 'h-11 rounded-xl bg-card px-3.5'} {...props} />
    </div>
)

export const FormError: FC<{ message: string | null }> = ({ message }): ReactNode => {
    if (!message) return null

    return (
        <p role='alert' className='rounded-xl border border-destructive/30 bg-destructive/5 px-3.5 py-2.5 text-sm text-destructive'>
            {message}
        </p>
    )
}
